// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1T8Kx","notes":"Notes_notes__3_7AQ","note":"Notes_note__3QAA4","markdown":"Notes_markdown__1n4Ij"};